export default "__VITE_PUBLIC_ASSET__aff933ee__"